import React from 'react'

const InternationalTransfersPage = () => {
  return (
    <div>InternationalTransfersPage</div>
  )
}

export default InternationalTransfersPage;